import React from 'react';

const UndoConfirmModal = ({ onClose, onConfirmUndo, onJumpToEnd }) => {
  return (
    <div
      className="modal-backdrop"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        zIndex: 99999,
        margin: 0,
        paddingTop: '120px',
        width: '100%'
      }}
    >
      <div
        className="modal-content"
        style={{
          width: 'calc(100% - 60px)',
          maxWidth: '600px',
          backgroundColor: '#121212',
          border: '5px solid #ffd700',
          borderRadius: '15px',
          padding: '30px',
          position: 'relative',
          boxSizing: 'border-box',
          marginBottom: '30px'
        }}
      >
        <div
          style={{
            fontSize: '45px',
            color: '#ffd700',
            textAlign: 'center',
            marginBottom: '10px',
            fontWeight: 'bold',
            letterSpacing: '3px'
          }}
        >
          Trim Postion
        </div>
        <div
          style={{
            fontSize: '24px',
            color: 'white',
            textAlign: 'center',
            marginBottom: '20px',
            lineHeight: '1.5',
            fontStyle: 'italic'
          }}
        >
          You can only undo the final move.
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <button
            className=""
            style={{
              fontSize: '24px',
              padding: '20px',
              backgroundColor: '#ff0000',
              border: 'none',
              color: 'white',
              border: '3px solid #ff0000',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={onConfirmUndo}
          >
            END LINE HERE
          </button>
          <button
            className="reg-buttons"
            style={{
              fontSize: '24px',
              padding: '20px',
              border: '3px solid #ffd700',
              color: '#ffd700',
              backgroundColor: 'transparent',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={onJumpToEnd}
          >
            JUMP TO FINAL MOVE
          </button>
          <button
            className="reg-buttons"
            style={{
              fontSize: '24px',
              padding: '20px',
              border: '3px solid white',
              color: 'white',
              backgroundColor: 'transparent',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={onClose}
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default UndoConfirmModal; 